export function formatINR(value, { compact = true } = {}) {
  const n = Number(value) || 0;
  if (compact) {
    if (n >= 10000000) return `₹${(n / 10000000).toFixed(2).replace(/\.00$/, "")} Cr`;
    if (n >= 100000) return `₹${(n / 100000).toFixed(2).replace(/\.00$/, "")} L`;
  }
  return `₹${n.toLocaleString("en-IN")}`;
}

export function formatINRFull(value) {
  return `₹${(Number(value) || 0).toLocaleString("en-IN")}`;
}

export function formatArea(value) {
  const n = Number(value) || 0;
  return `${n.toLocaleString("en-IN")} Sq.Ft`;
}

export function formatDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return "—";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${dd}/${mm}/${d.getFullYear()}`;
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return "—";
  return `${formatDate(iso)} · ${d.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: true })}`;
}

export function relativeTime(iso) {
  if (!iso) return "";
  const diff = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days < 30) return `${days}d ago`;
  return formatDate(iso);
}

export function initials(name) {
  if (!name) return "?";
  return name.split(" ").map((n) => n[0]).slice(0, 2).join("").toUpperCase();
}

export function telHref(phone) {
  return `tel:${(phone || "").replace(/\s/g, "")}`;
}
export function waHref(phone) {
  const clean = (phone || "").replace(/[^0-9]/g, "");
  return `https://wa.me/${clean.startsWith("91") ? clean : "91" + clean}`;
}
export function mailHref(email) {
  return `mailto:${email || ""}`;
}
